import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Button, Dialog } from "@mui/material";
import { DialogContent, Divider, Stack, Typography } from "@mui/material";
import { Toast } from "../../components/components/Toast";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";

function AddToStore({ onClose, onSuccess, items }) {
  const [storeLoad, setStoreLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState(null);
  const [stores, setStores] = useState([]);

  useEffect(() => {
    getStore();
  }, []);

  const getStore = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.store({
        request: {
          method: "getStore",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        if (data.response.data.stores.length > 0) {
          setStores(data.response.data.stores);
        } else {
          setStores([]);
        }
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const handleAddToStore = async () => {
    try {
      let filtered = items.map((i) => {
        return {
          _id: i._id,
          name: i.name,
          itemId: i.itemId,
          imgURL: i?.imgURL || "",
          price: i?.price,
        };
      });

      let { data } = await Repo.store({
        request: {
          method: "updateStore",
          data: {
            _id: stores[0]._id,
            company_code: localStorage.getItem("companyCode"),
            itemsArray: filtered,
          },
        },
      });
      onSuccess();
      if (data.response.status.statusCode == 200) {
        Toast("success", "Items added to Store");
      } else {
        Toast("error", data.response.status.statusMessage);
      }
    } catch (err) {
      onClose();
      console.log(err);
      Toast("error", "Error");
    }
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setState(value);
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Stack width="100%">
            <Typography
              sx={{
                color: "#4CAF50",
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "center",
                fontFamily: "Roboto",
              }}
            >
              Add Items To Store
            </Typography>
            <Divider sx={{ mt: "16px", color: "#afafaf" }} />
          </Stack>

          {/* {storeLoad && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <Typography>Fetching stores...</Typography>
              <ClipLoader size={35} loading={true} color="#4eaf51" />
            </Stack>
          )}
          {!storeLoad && (
            <FormControl fullWidth size="small">
              <InputLabel>Add to store</InputLabel>
              <Select
                size="small"
                value={state}
                label="Add to store"
                onChange={handleInput}
              >
                <MenuItem value={stores[0]._id}>Ten</MenuItem>
              </Select>
            </FormControl>
          )} */}

          {loading && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <ClipLoader size={32} loading={true} color="#4eaf51" />
            </Stack>
          )}
          {!loading && stores.length == 0 && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <Typography variant="h6">No store found</Typography>
            </Stack>
          )}
          {!loading && stores.length > 0 && (
            <Stack direction="row" width="100%" justifyContent="space-evenly">
              <Button
                variant="contained"
                sx={{
                  background: "#F2F2F2 !important",
                  color: "#767676",
                  textTransform: "none",
                  minWidth: "100px",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ textTransform: "none", minWidth: "100px" }}
                onClick={handleAddToStore}
              >
                Add
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddToStore;
